import React from 'react';

const StardustTheme = {
  headerLogo: {
    src: '/themes/theme/stardust/logo-stardust-light.svg',
    alt: 'Stardust influencers',
    size: 100,
  },
  darkLogo: {
    src: '/themes/theme/stardust/logo-stardust.svg',
    alt: 'Stardust influencers',
    size: 150,
  },
  headerStyle: {
    backgroundColor: '#110',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#FFF',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'STARDUST | CAMPAIGNS',
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="150" src="/themes/theme/stardust/logo-stardust.svg" alt="Stardust Influencers" />
    </div>
  ),
  shareSite: 'https://stardustr.dyzio.co',
  organisationId: 'f11da016-ca79-4f3a-9fe4-1f03bb8ee6c3',
};

export default StardustTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/stardust.js
 **/